import script from "./SampleLightbox.vue?vue&type=script&setup=true&lang=js"
export * from "./SampleLightbox.vue?vue&type=script&setup=true&lang=js"

import "./SampleLightbox.vue?vue&type=style&index=0&id=e9c0f30c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9c0f30c"]])

export default __exports__